export type Source = 'kwork' | 'fl' | 'freelance' | 'freelancer' | 'weblancer' | 'workspace' | 'contractis' | 'freelancehunt' | 'telegram'
export type OrderStatus = 'new' | 'viewed' | 'responded' | 'ignored'
export type DisplayCurrency = 'KGS' | 'RUB' | 'USD'

export interface Order {
  id: string
  source: Source
  title: string
  description: string
  budgetAmount: number | null
  budgetCurrency: string
  displayBudgetAmount: number | null
  displayBudgetCurrency: DisplayCurrency
  url: string
  publishedAt: string
  relevance: number
  scoreSource: 'ai' | 'fallback'
  customer?: string
  favorite: boolean
  status: OrderStatus
  response?: string
}

export interface OrderFilters {
  sources: Source[]
  minBudget: number
  minRelevance: number
  statuses: OrderStatus[]
}

export interface Settings {
  sources: Source[]
  minBudget: number
  minRelevance: number
  keywords: string[]
  stopWords: string[]
  telegramChannels: string[]
  lastSuccessfulScan: string | null
  displayCurrency: DisplayCurrency
  exchangeRates: Record<string, number>
}

export interface ScanRun {
  id: string
  status: 'queued' | 'running' | 'success' | 'partial' | 'failed'
  startedAt: string
  finishedAt?: string
  found?: number
  error?: string
}

export const sourceLabels: Record<Source, string> = {
  kwork: 'Kwork',
  fl: 'FL.ru',
  freelance: 'Freelance.ru',
  freelancer: 'Freelancer.com',
  weblancer: 'Weblancer',
  workspace: 'Workspace',
  contractis: 'Contractis',
  freelancehunt: 'Freelancehunt',
  telegram: 'Telegram',
}
